
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.744 34.035a19.458 19.458 0 0017.552 7.29l-1.21-10.337a9.05 9.05 0 01-8.164-3.391l-8.178 6.438z","fill":"#0A38C9"}}),_c('path',{attrs:{"d":"M28.746 3.596a19.606 19.606 0 00-16.66 1.483l5.33 9.107a9.053 9.053 0 017.693-.685l3.637-9.905z","fill":"#194BFB"}}),_c('path',{attrs:{"d":"M38.86 7.868a22 22 0 00-9.324-6.537l-4.437 12.168a9.048 9.048 0 013.836 2.689l9.926-8.32z","fill":"#F1104E"}}),_c('path',{attrs:{"d":"M38.886 31.728a19.46 19.46 0 00-1.943-22.234l-7.968 6.683a9.059 9.059 0 01.904 10.35l9.007 5.201z","fill":"#0A38C9"}}),_c('path',{attrs:{"d":"M.75 16.306a22 22 0 004.055 19.417l10.118-8.075a9.055 9.055 0 01-1.67-7.991L.75 16.306zM23.954 43.913A22 22 0 0043.934 23.7l-12.916-1a9.044 9.044 0 01-8.215 8.31l1.15 12.904z","fill":"#194BFB"}}),_c('path',{attrs:{"d":"M13.108 6.577A17.809 17.809 0 004.81 17.392l9.259 2.48A8.223 8.223 0 0117.9 14.88l-4.793-8.302z","fill":"#0A38C9"}}),_c('path',{attrs:{"d":"M22.048 12.935a9.066 9.066 0 100 18.132 9.066 9.066 0 000-18.132zm0 13.599a4.533 4.533 0 110-9.066 4.533 4.533 0 010 9.066z","fill":"#fff"}}),_c('circle',{attrs:{"cx":"5.537","cy":"5.537","transform":"matrix(-1 0 0 1 27.547 16.46)","fill":"#091540","r":"5.537"}}),_c('ellipse',{attrs:{"cx":"1.617","cy":"1.675","rx":"1.617","ry":"1.675","transform":"matrix(-1 0 0 1 25.75 18.594)","fill":"#fff"}})])
          )
        }
      }
    